module.exports = __webpack_public_path__ + "static/media/compensation.75a2a5df.svg";